// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TagSelector-cls1___9635bffbafb0a8b5404{/*!*/}.TagSelector-cls2___d791f55137c14f0acbc{color:#535366}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "TagSelector-cls1___9635bffbafb0a8b5404",
	"cls2": "TagSelector-cls2___d791f55137c14f0acbc TagSelector-cls1___9635bffbafb0a8b5404"
};
export default ___CSS_LOADER_EXPORT___;
